import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError, ok } from "@nju/result";
import { ISetBlockUnblockStatus, ISetToggleBlockSimCardResult } from "./types";

interface ISetToggleBlockSimCardParams {
  productId: string;
  action: ISetBlockUnblockStatus;
}

const actionToMap = {
  block: "Y",
  unblock: "N",
} as const;

export async function setToggleBlockSimCard({
  productId,
  action,
}: ISetToggleBlockSimCardParams): Promise<ISetToggleBlockSimCardResult> {
  const blockAction = actionToMap[action];

  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/products/${productId}/characteristics`,
    {
      method: "patch",
      headers: {
        "Accept-Language": "pl",
        "Client-Id": process.env.NEXT_PUBLIC_CLIENT_ID || "unknown",
      },
      json: {
        characteristic: [
          {
            name: "barringAdmFull",
            value: blockAction,
          },
        ],
      },
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(undefined);
}
